import { json, jsonParseLinter } from '@codemirror/lang-json'
import { linter } from '@codemirror/lint'
import { CodeEditorV2, stringify } from '@portal/components'
import React from 'react'

import { DQLResult } from '../../types'
import NoResults from './NoResults'
import { DQLMutationResult } from './QueryResultTable'

type QueryResultJsonProps = {
  data: DQLResult[] | DQLMutationResult[]
}

export default function QueryResultJson({ data }: QueryResultJsonProps) {
  const jsonLinter = linter(jsonParseLinter())

  return (
    <div className="h-full overflow-y-auto bg-background-surface">
      {data.length ? (
        <CodeEditorV2
          height="auto"
          basicSetup={{
            lineNumbers: true,
            highlightActiveLineGutter: false,
          }}
          value={stringify(data, null, 2)}
          language={json()}
          readOnly={true}
          linter={jsonLinter}
        />
      ) : (
        <NoResults />
      )}
    </div>
  )
}
